import { useDispatch, useSelector } from "react-redux";
import { hasAuthority } from "../../../../../utils/authorities";
import { Grid } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { selectAllInitialSteps, selectCurrentCycle } from "../../../../slices/common";
import { ApproveCarTForm, selectIsSubmitLoading } from "../../../../slices/carTForm";
//import { productFailManufacturing } from "../../../../slices/manufacturer";

const CarTFormButtons = ({
    //patientData,
    // fetchPatientInfo,
    formik,
    updateTimeLine,
    setCarTFormExpanded,
    setIsDraft,
    // fetchCarTForms
}) => {
    const dispatch = useDispatch();
    const currentCycle = useSelector(selectCurrentCycle)
    const isSubmitLoading = useSelector(selectIsSubmitLoading)
    const LoginData = useSelector((state) => state.loginData);
    const bmr_permissions = LoginData?.bmr_permissions || [];
    const carTFormId = currentCycle?.car_t_manufacturing_form_id
    const allInitialSteps = useSelector(selectAllInitialSteps)
    const approvalStatus = allInitialSteps?.find(op => op.slug == "product-manufactured")

    const handleApproved = async () => {
         if (!formik.values.remarks_lead) {
        formik.setFieldError('remarks_lead', 'Remarks are required for approval');
        formik.setTouched({ remarks_lead: true }, false);
        return;
    }
        const formData = {
            id: carTFormId,
            data: {
                 remarks_lead: formik.values.remarks_lead
                 }
        };
        await dispatch(ApproveCarTForm(formData));
        await updateTimeLine()
        setCarTFormExpanded(false)
        // await fetchCarTForms(patientData?.patient_information?.car_t_form_id)
    }
/*
 const handleReject = async () => {
    try {
     if (!formik.values.remarks_lead) {
        formik.setFieldError('remarks_lead', 'Remarks are required for rejection');
        formik.setTouched({ remarks_lead: true }, false);
        return;
    }
            const payload = {
                car_t_form_id: carTFormId,
                subject_id: patientData?.subject_id,
                feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
                qr_code_generated_id: patientData?.id,
                product_manufacturing_stages_id: currentCycle?.product_manufacturing_id,
                comment:
                    formik.values.remarks_lead || "Manufacturing failed",
            };
            const res = await dispatch(productFailManufacturing(payload)).unwrap();
            if (res?.status == 200) {
                setCarTFormExpanded(false)
                // await fetchCarTForms(patientData?.patient_information?.car_t_form_id)
                await updateTimeLine()
            }
        } catch (err) {
            console.error("Error failing manufacturing:", err);
        }
    }*/

    return <div>
        <Grid className="flex gap-4 w-full max-w-[35rem]">
            {approvalStatus?.status == 1 && hasAuthority(["start-manufacturing"], bmr_permissions) && 
            <LoadingButton
                loading={isSubmitLoading}
                type="submit"
                variant="contained"
                className="w-25"
               onClick={() => setIsDraft(false)}
            >
                Submit
            </LoadingButton>}
             {approvalStatus?.status == 1 && hasAuthority(["start-manufacturing"], bmr_permissions) && <LoadingButton
                                    type="submit"
                                    size="small"
                                    onClick={() => setIsDraft(true)}
                                    className="!w-[100px] bg-[#ffa500]"
                                  >
                                    Save as Draft
                                  </LoadingButton>}
            {carTFormId
                && (hasAuthority(["manufacturing-approve"], bmr_permissions))
                && approvalStatus?.status == 5
                && (formik.values.approved_by == null || formik.values.approved_by == "")
                && <LoadingButton
                    loading={isSubmitLoading}
                    type="button"
                    onClick={() => handleApproved()}
                    variant="contained"
                    className="w-25  bg-[#00B976]"
                >
                    Approve
                </LoadingButton>}
            {/*carTFormId
                && hasAuthority(["failed-manufacturing-lead"], bmr_permissions)
                && approvalStatus?.status == 5
                && (formik.values.approved_by == null || formik.values.approved_by == "")
                && <LoadingButton
                    type="button"
                    onClick={() => handleReject()}
                    className="w-25 bg-[#FF5757] text-white hover:bg-[#FF4444]"
                    variant="contained"

                >
                    Mark As Failed
                </LoadingButton>*/}
        </Grid>
    </div >
}
export default CarTFormButtons;